/** Static public PDF URLs (copied to dist/img on build). */
const PDF_V = "20260719b";

export const menuPdfs = {
  foods: {
    href: `/img/mizuetlap.pdf?v=${PDF_V}`,
    download: "MIZU-etlap.pdf",
    labelKey: "foods",
  },
  drinks: {
    href: `/img/itallap.pdf?v=${PDF_V}`,
    download: "MIZU-itallap.pdf",
    labelKey: "drinks",
  },
};
